<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="loading-screen fixed inset-0 z-[1000] flex flex-col items-center justify-center bg-producer-slate-loading"
      data-test="producer-loadingScreen"
    >
      <lottie
        :height="150"
        :width="150"
        :animationData="animationData"
      />
    </div>
  </transition>
</template>

<script lang="js">
import { Vue3Lottie as Lottie } from 'vue3-lottie';

import hashyLoader from '../../assets/lottie/hashyAnimation.json';

export default {
  components: {
    Lottie,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isVisible: this.visible,
      animationData: hashyLoader,
    };
  },

  watch: {
    visible(isVisible) {
      clearTimeout(this.visibleTimeout);

      if (isVisible) {
        this.isVisible = isVisible;
      } else {
        // Delay hiding the loading screen a bit
        this.visibleTimeout = setTimeout(() => {
          this.isVisible = isVisible;
        }, 1e3);
      }
    },
  },
};
</script>
